import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';


import {
  Container,
  CardOrder,
  MainContainer
} from '~/components/layout/Logistic/styles';
import {
  TitlePage as IconsTop,
  CloseIconStyled as IconStyled,
  Title,
  HeaderMessage,
  HeaderAccountMessage,
  CardInputItem,
  ButtonDivision,
  LoadingIcon,
  BankSlipsContainer,
  WrapperBankslips,
  DesktopWrapper,
  MobileWrapper,
  MessageNothing,
  BankslipMessage,
} from './styles';
import close from '~/assets/images/close.png';
import '~/components/styles/Global.css';
import { InfoButton } from '~/components/layout/Buttons';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import AttachmentProgressBar from '~/components/layout/Logistic/AttachmentProgressBar';
import ProgressButton from '~/components/layout/ProgressButton';

import DesktopCashPayment from '~/components/pages/Logistic/CashPayment/CashPaymentDesktop';
import MobileCashPayment from '~/components/pages/Logistic/CashPayment/CashPaymentMobile';
import api from '~/services/api';

import { sendAttachmentValidate } from '~/components/layout/Logistic/Attachment'
import { mapAccount } from '~/utils/functions/mapperAccount';

export default function CashPayment() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [openModalMobile, setOpenModalMobile] = useState(false);
  const [loading, setLoading] = useState(false);

  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [showButton, setShowButton] = useState([])
  const [hasAttachment, setHasAttachment] = useState(false)

  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticPaymentReducer = useSelector(state => state.logisticPaymentReducer);
  const code = useSelector((state) => state.branchCode.code)

  const response = mapAccount(code)

  useEffect(() => {
    requestOrder();
  }, []);

  const requestOrder = async () => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    let url = `/sales/order/v2/orders-ga/${logisticPaymentReducer.order.id}/attachments`;

    api
      .get(url, parameters)
      .then(res => {
        setLoading(false);
        setHasAttachment(false)
      })
      .catch(err => {
        if (err.response.status === 400 && err.response.data.resultado.mensagem === "O pedido não contém anexo.") {
          setHasAttachment(true)
        }

      });
    setLoading(false);
  };


  function handleOpenModal(bankSlip) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: bankSlip,
    });
    setOpenModal(!openModal);
  }

  function handleOpenModalMobile(bankSlip) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: bankSlip,
    });
    setOpenModalMobile(!openModalMobile);
  }


  const handleShowButton =(props) => {
    setShowButton((oldState)=> {
      const showButtonFilter = oldState.filter(item => item.id !== props.id)
      return [...showButtonFilter, {id: props.id, status: props.status}]})
    }
  const hideButton = showButton.filter(item => item.status === false);

  const attachmentCount = useMemo(() => {
    return showButton.length - hideButton.length;
  }, [hideButton, showButton]);

  const handleFinishButton = async (e) => {
    if (hideButton.length > 0) {
      toast.warn((
        <span>
          É necessário anexar todos os comprovantes!
          <br/>
          Comprovantes Anexados: <b>{attachmentCount}</b> de <b>{showButton.length}</b>
        </span>));
      return;
    }
    await sendAttachmentValidate(logisticPaymentReducer.order.id, setLoadingConfirm);
    toast.success('O(s) anexo(s) do(s) comprovante(s) está(ão) em análise');
    history.push('/portal');
  }

  const isMobile = window.screen.width < 771;
  return (
    <Container>
      {verifyRoles(roles, 'STATUS_DO_PEDIDO') ? (
        <>
          <IconsTop>
            <div />
            <IconStyled
              src={close}
              alt="Ícone de fechar"
              onClick={() => history.push('/portal')}
            />
          </IconsTop>
            <CardOrder>
              <MainContainer>
                <Title>
                  <span>Pagamento a Vista</span>
                </Title>
                <CardInputItem>
                  <Row>
                    <Col>
                      <Row>
                        <HeaderMessage isMobile={isMobile}>
                          Utilize a conta abaixo para seguir com o pagamento por meio de depósito bancário.
                        </HeaderMessage>
                        <HeaderAccountMessage isMobile={isMobile}>
                          <b>Banco:</b> Itaú (341)
                        </HeaderAccountMessage>
                        <HeaderAccountMessage isMobile={isMobile}>
                          <b>Agência:</b> {response.agencia}
                        </HeaderAccountMessage>
                        <HeaderAccountMessage isMobile={isMobile}>
                          <b>Conta corrente:</b> {response.conta}
                        </HeaderAccountMessage>
                        <HeaderAccountMessage isMobile={isMobile} last={true}>
                          <b>CNPJ:</b> {response.CNPJ}
                        </HeaderAccountMessage >
                        <HeaderMessage isMobile={isMobile} >
                          Ao realizar o pagamento, nos envie o comprovante, através do botão "Anexar Comprovante". <br/>
                          Após o envio, nossa equipe analisará os dados informados e dará andamento ao seu pedido.
                        </HeaderMessage>
                      </Row>
                    </Col>
                  </Row>
                </CardInputItem>
                <WrapperBankslips>
                    {loading ? (
                      <Loading />
                    ) : (
                      <>
                        {!logisticPaymentReducer.order ? (
                          <BankslipMessage>
                            <span>Nenhum pedido encontrado</span>
                          </BankslipMessage>
                        ) : (
                          <BankSlipsContainer>
                            { showButton.length > 0 && (
                              <AttachmentProgressBar
                                total={showButton.length}
                                value={attachmentCount}
                                title="Comprovantes Anexados:"
                                countType="LABEL"
                              />
                            )}
                            <DesktopWrapper>
                              <DesktopCashPayment
                                 data={logisticPaymentReducer.order}
                                 key={1}
                                 openModal={() => handleOpenModal(logisticPaymentReducer.order)}
                                 handleShowButton={handleShowButton}
                              />
                            </DesktopWrapper>
                            <MobileWrapper>
                              <MobileCashPayment
                                data={logisticPaymentReducer.order}
                                key={1}
                                openModal={() =>
                                  handleOpenModalMobile(logisticPaymentReducer.order)
                                }
                                handleShowButton={handleShowButton}
                              />
                            </MobileWrapper>
                            { !logisticPaymentReducer.order && (
                              <MessageNothing>
                                Nenhum resultado encontrado
                              </MessageNothing>
                            )}
                          </BankSlipsContainer>
                        )}
                      </>
                    )}
                  </WrapperBankslips>
                  <ButtonDivision onClick={handleFinishButton}>
                    { hideButton.length > 0 ? (
                        <ProgressButton text="Comprovantes Anexados:"
                          value={attachmentCount}
                          total={showButton.length}/>
                      ) : (
                      <InfoButton style={{ margin: "-1rem 0 1rem 0" }} disabled={loadingConfirm}>
                        {loadingConfirm ? (
                          <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                        ) : (
                          <div>Finalizar</div>
                        )}
                      </InfoButton>
                      )}
                </ButtonDivision>
              </MainContainer>
              <OpenChatBot backgroundColor={'#00f3ff'} />
            </CardOrder>

        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
